import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { SmoothScroll, ScrollToTop } from "./components/SmoothScroll";
import Layout from "./components/Layout";

import Home from "./pages/Home";
import Tools from "./pages/Tools";
import NumerologyCalculator from "./pages/tools/NumerologyCalculator";
import PalmReading from "./pages/tools/PalmReading";
import LoShuGrid from "./pages/tools/LoShuGrid";
import LoveCalculator from "./pages/tools/LoveCalculator";
import NumerologyReport from "./pages/tools/NumerologyReport";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import BlogAdmin from "./pages/BlogAdmin";
import AIChat from "./pages/AIChat";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Legal from "./pages/Legal";
import NotFound from "./pages/NotFound";

function App() {
  return (
    <BrowserRouter>
      <SmoothScroll>
        <ScrollToTop />
        <Toaster position="top-center" richColors />
        <Routes>
          <Route path="/" element={<Layout><Home /></Layout>} />
          <Route path="/tools" element={<Layout><Tools /></Layout>} />
          <Route path="/tools/numerology-calculator" element={<Layout><NumerologyCalculator /></Layout>} />
          <Route path="/tools/palm-reading" element={<Layout><PalmReading /></Layout>} />
          <Route path="/tools/lo-shu-grid" element={<Layout><LoShuGrid /></Layout>} />
          <Route path="/tools/love-calculator" element={<Layout><LoveCalculator /></Layout>} />
          <Route path="/tools/numerology-report" element={<Layout><NumerologyReport /></Layout>} />
          <Route path="/blog" element={<Layout><Blog /></Layout>} />
          <Route path="/blog/:slug" element={<Layout><BlogPost /></Layout>} />
          <Route path="/blog-admin" element={<Layout hideFooter><BlogAdmin /></Layout>} />
          <Route path="/chat" element={<Layout><AIChat /></Layout>} />
          <Route path="/about" element={<Layout><About /></Layout>} />
          <Route path="/contact" element={<Layout><Contact /></Layout>} />
          <Route path="/privacy" element={<Layout><Legal type="privacy" /></Layout>} />
          <Route path="/terms" element={<Layout><Legal type="terms" /></Layout>} />
          <Route path="/disclaimer" element={<Layout><Legal type="disclaimer" /></Layout>} />
          {/* Redirect old Numora URLs to new URLs */}
<Route path="/calculator" element={<Navigate to="/tools/numerology-calculator" replace />} />
<Route path="/palm-reading" element={<Navigate to="/tools/palm-reading" replace />} />
<Route path="/lo-shu-grid" element={<Navigate to="/tools/lo-shu-grid" replace />} />
          <Route path="*" element={<Layout><NotFound /></Layout>} />
        </Routes>
      </SmoothScroll>
    </BrowserRouter>
  );
}

export default App;
